<template>
	<b-card no-body class="m-0">
		<b-card-header header-tag="header" class="p-0" role="tab">
			<b-button block v-b-toggle.accordion-warranty variant="light" class="py-4 accordion-button">GARANTIZADO</b-button>
		</b-card-header>
		<b-collapse id="accordion-warranty" accordion="services-accordion" role="tabpanel">
			<b-card-body>
				<b-img src="images/tabs/mobile/garantizados/garantizados.png" alt="garantizados" fluid-grow />
				<div class="bg-white py-4 px-2 text-left" style="border-radius: 20px">
					<div style="font-size: 17px;"><b>PLANES FULL COBERTURA</b></div>
					<div style="font-size: 32px;">Hasta $2.000.000</div>
					<div style="font-size: 12px" class="my-3">
						Servicios MOK Automotriz coordinará el ingreso de tu vehículo al taller adherido más cercano pagando los costos de reparación. Además incluimos todos los beneficios de Asistencia en Ruta MOK.
					</div>
					<div style="border-radius: 20px; border: 2px solid #F1802D" class="p-3">
						<div class="text-center mb-2" style="font-size: 18px; color: #F1802D; vertical-align: middle">
							Servicios Adicionales
						</div>
						<div style="font-size: 12px">
							Pago y Traslado Revisión Técnica <br />
							Conductor de reemplazo <br />
							Vehículo de reemplazo RM <br />
							Hotel de estadía
						</div>
					</div>
				</div>
				<interested :service_type_id="2"></interested>
			</b-card-body>
		</b-collapse>
	</b-card>
</template>

<script>
import Interested from '../components/interested';
  export default {
	name: 'v-tab-warrany',
	components:{
			Interested
		},
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
